import { Box, Paper, Typography } from '@material-ui/core';
import dayjs from 'dayjs';

import { FormQuestion, Visualization } from '@vyce/core/src/types';

import { FormResultResponses } from './FormResultResponses';

export const FormResultDate = ({
  type,
  question,
  visualization,
}: {
  type: 'date' | 'time';
  question: FormQuestion;
  visualization: Visualization | undefined;
}) => {
  const points = visualization?.type === 'text_list' ? visualization.data : [];

  const noAnswersCount =
    question?.answer.type === 'date' || question?.answer.type === 'time'
      ? points.filter(point => typeof point.value !== 'string' || !point.value).length
      : 0;

  const answers = points.filter(point => typeof point.value === 'string' && Boolean(point.value));

  const groupedAnswers = answers.reduce((acc, answer) => {
    const value = answer.value;
    if (typeof value !== 'string' || !value) return acc;

    const existing = acc.find(item => item.value === value);
    if (existing) {
      existing.count += 1;
      if (answer.participantName && !existing.participantNames.includes(answer.participantName)) {
        existing.participantNames.push(answer.participantName);
      }
    } else {
      acc.push({
        value,
        count: 1,
        participantNames: answer.participantName ? [answer.participantName] : [],
      });
    }
    return acc;
  }, [] as Array<{ value: string; count: number; participantNames: string[] }>);

  const paperStyle = {
    padding: 24,
    width: '100%',
    height: '100%',
    marginTop: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };

  return (
    <Box width="100%">
      {groupedAnswers.map((groupedAnswer, index) => (
        <Paper
          key={`${groupedAnswer.value}-${index}`}
          variant="outlined"
          style={{
            ...paperStyle,
          }}
        >
          <Box display="flex" alignItems="center" gridGap={8}>
            <Typography variant="body1" color="textSecondary">
              {type === 'date' ? dayjs(groupedAnswer.value).format('DD/MM/YYYY') : groupedAnswer.value}
            </Typography>
          </Box>

          <FormResultResponses count={groupedAnswer.count} names={[]} />
        </Paper>
      ))}
      <Paper variant="outlined" style={{ ...paperStyle }}>
        <Typography variant="body1" color="textSecondary">
          No answers
        </Typography>

        <FormResultResponses count={noAnswersCount} names={[]} />
      </Paper>
    </Box>
  );
};
